"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Subreddit = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Header = require("./Header");

var _Header2 = _interopRequireDefault(_Header);

var _Sidebar = require("./Sidebar");

var _Sidebar2 = _interopRequireDefault(_Sidebar);

var _FooterParent = require("./FooterParent");

var _FooterParent2 = _interopRequireDefault(_FooterParent);

var _Loading = require("./Loading");

var _Loading2 = _interopRequireDefault(_Loading);

var _util = require("../util");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Subreddit = function Subreddit(_ref) {
  var _ref$Loading = _ref.Loading,
      Loading = _ref$Loading === undefined ? _Loading2.default : _ref$Loading,
      _ref$Header = _ref.Header,
      Header = _ref$Header === undefined ? _Header2.default : _ref$Header,
      _ref$Sidebar = _ref.Sidebar,
      Sidebar = _ref$Sidebar === undefined ? _Sidebar2.default : _ref$Sidebar,
      _ref$FooterParent = _ref.FooterParent,
      FooterParent = _ref$FooterParent === undefined ? _FooterParent2.default : _ref$FooterParent,
      children = _ref.children,
      isLoading = _ref.isLoading,
      subreddit = _ref.subreddit,
      style = _ref.style,
      _ref$useSidebar = _ref.useSidebar,
      useSidebar = _ref$useSidebar === undefined ? true : _ref$useSidebar,
      useStyle = _ref.useStyle,
      props = _objectWithoutProperties(_ref, ["Loading", "Header", "Sidebar", "FooterParent", "children", "isLoading", "subreddit", "style", "useSidebar", "useStyle"]);

  return [useStyle && style.stylesheet ? _react2.default.createElement(
    "style",
    { key: "style" },
    style.stylesheet
  ) : null, (0, _util.optional)(Header, _extends({}, props, { key: "header", subreddit: subreddit })), useSidebar ? (0, _util.optional)(Sidebar, _extends({}, props, { subreddit: subreddit, key: "sidebar" })) : null, _react2.default.createElement("a", { name: "content", key: "anchor" }), children, (0, _util.optional)(FooterParent, _extends({}, props, { key: "footer" })), isLoading ? (0, _util.optional)(Loading, _extends({}, props, { key: "loading" })) : null, _react2.default.createElement("img", { id: "hsts_pixel", key: "hsts_pixel" }), _react2.default.createElement(
    "p",
    { className: "bottommenu debuginfo", key: "debuginfo" },
    ",",
    _react2.default.createElement(
      "span",
      { className: "icon" },
      "\u03C0"
    ),
    "\xA0",
    _react2.default.createElement(
      "span",
      { className: "content" },
      "Rendered by go1dfish on open-source-reddit at 2017-10-22 02:55:43.787032+00:00 running 753b174 ."
    )
  )];
};

exports.Subreddit = Subreddit;
exports.default = Subreddit;


//////////////////
// WEBPACK FOOTER
// ./node_modules/snew-classic-ui/build/components/Subreddit.js
// module id = 739
// module chunks = 0